// Temporary email-based access control per-route.
// Add entries where the key is a route path (exact match or prefix when ending with "*")
// and the value is an array of allowed email addresses.
// Example:
// export const emailAccessByRoute = {
//   "/conversations": ["admin@example.com", "lead@example.com"],
//   "/jobs-list": ["recruiter@example.com"],
//   "/workspace*": ["teamlead@example.com"], // prefix match for all /workspace routes
// };

// const allowedEmailsClient = [
//   "tm@vylabs.ai",
//   "vish@vylabs.ai",
//   "richu@vysystems.com",
//   "vyrp@vylabs.ai",
//   "dineshkumar@vybog.com",
//   "pradeep@vybog.com",
//   "gnana.mary@vybog.com",
//   "yesh@vylabs.ai",
//   "nandhakumar@codenatives.com",
//   "immanuel@vylabs.ai",
//   "himangshu@vylabs.ai",
//   "ramesh@vysystems.com",
//   "tm@vybog.com",
//   "ramanathanr7777@gmail.com",
//   "rameshkumar@vybog.com",
//   "praveen.g@vysystems.com",
//   "maga@vysystems.com",
//   "salome.ravi@vybog.com",
//   "aruna@vysystems.com",
//   "karthik.rg@vysystems.com",
//   "palanikumar@vysystems.com",
//   "rahul@vyvoxel.com",
//   "thiru@vysystems.com",
//   "vasanth@vysystems.com",
//   "reshma@vysystems.jobs",
//   "harishkumar@vysystems.com",
// ];

// const allowedEmailsVendors = [
//   "tm@vylabs.ai",
//   "vish@vylabs.ai",
//   "richu@vysystems.com",
//   "vyrp@vylabs.ai",
//   "dineshkumar@vybog.com",
//   "pradeep@vybog.com",
//   "gnana.mary@vybog.com",
//   "yesh@vylabs.ai",
//   "nandhakumar@codenatives.com",
//   "immanuel@vylabs.ai",
//   "himangshu@vylabs.ai",
//   "ramesh@vysystems.com",
//   "tm@vybog.com",
//   "ramanathanr7777@gmail.com",
//   "rameshkumar@vybog.com",
//   "maga@vysystems.com",
//   "salome.ravi@vybog.com",
//   "aruna@vysystems.com",
//   "karthik.rg@vysystems.com",
//   "palanikumar@vysystems.com",
//   "rahul@vyvoxel.com",
//   "thiru@vysystems.com",
//   "vasanth@vysystems.com",
//   "harishkumar@vysystems.com",
// ];

export const emailAccessByRoute = {
  // Fill with route-to-allowed-emails mapping, e.g.:
  // "/user-dashboard": ["you@example.com"],
  // "/clients-list": allowedEmailsClient,
  // "/vendors": allowedEmailsVendors,
};

// Where to redirect users who are not authorized for a restricted route
export const emailRestrictionFallbackPath = "/dashboard";

// Routes (exact or prefix with *) where the side menu should be hidden
export const sideMenuHiddenRoutes = [
  //"/clients-list",
];

// Hide the side menu for these user emails (applies across all routes)
export const sideMenuHiddenForEmails = [
  //"tm@vylabs.ai",
  //"vyrp@vylabs.ai",
];
